var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoaderStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 71,
    viewBox: "0 0 60 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.053 20.3351C51.138 28.1166 53.6753 52.0344 50.2756 60.901C48.5477 65.4073 44.8569 64.4235 41.4414 65.3387C38.2046 66.206 35.6098 68.8837 31.8892 65.8276C23.959 59.3137 13.3583 35.8732 11.2178 27.8849C8.07309 16.1486 18.2352 19.2755 28.3711 16.5596C38.5069 13.8437 45.9083 8.59888 49.053 20.3351Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6294 15.0226C48.0576 16.6206 46.5087 20.4993 40.4922 21.2277C34.0058 24.0661 30.7451 26.2761 26.1295 27.5128C15.9937 30.2287 11.7104 27.7918 10.9242 24.8578C10.1381 21.9237 17.7175 17.3435 27.8533 14.6276C37.9892 11.9117 46.8432 12.0886 47.6294 15.0226Z",
    fill: "#FBE54D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1295 27.5128C15.9937 30.2287 11.7104 27.7918 10.9242 24.8578C10.1381 21.9237 17.7175 17.3435 27.8533 14.6276C37.9892 11.9117 46.8432 12.0886 47.6294 15.0226C48.0576 16.6206 46.5087 20.4993 40.4922 21.2277M26.1295 27.5128C30.7451 26.2761 34.0058 24.0661 40.4922 21.2277M26.1295 27.5128L40.4922 21.2277",
    stroke: "#351771",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0782 7.93745C25.0346 6.35098 23.9111 15.0199 24.1048 19.5527C29.0443 20.1192 39.795 21.1958 43.2817 20.9691C47.6401 20.6858 47.059 14.4533 47.059 13.0368C47.059 11.6203 43.8628 3.68795 40.6667 2.27146C37.4705 0.854976 38.6328 5.38774 38.9233 6.52093C39.2139 7.65412 38.6327 9.92053 31.0782 7.93745Z",
    fill: "#FFF18F",
    fillOpacity: 0.9,
    stroke: "#351771",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.692 21.7297C14.8835 22.4821 4.58472 33 31.5847 26L43.5847 21C49.5847 16 40.7338 16.7459 34.0847 18C27.4356 19.2541 19.6709 10.1296 18.341 7.62142C17.0112 5.11327 17.8091 11.0701 14.3516 10.1296C10.894 9.18902 7.96841 11.0701 9.03227 12.6377C10.0961 14.2053 10.6281 15.4593 9.03227 16.3999C7.43648 17.3404 2.64915 16.3999 2.11722 19.8486C1.58529 23.2973 7.70248 20.7891 11.692 21.7297Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderStep3);
export default __webpack_public_path__ + "static/media/loader-step-3.85be2f03990ab5bf04324c82a72420ee.svg";
export { ForwardRef as ReactComponent };